import { IAppState } from '../../common/state';
import { TPromoSearchTypes } from '../../types/promoSearchTypes';

export const selectPromoSearchTypes = (state: IAppState): TPromoSearchTypes => state.filters.promoSearchTypes;
